<template>
<div>
    <v-app>
      <v-content>
        <EPSDashboard
          :columns="cols"
          :permitting-authorities="pas"
          :env="env"
          :filters="fils"></EPSDashboard>
      </v-content>
    </v-app>
</div>
</template>

<script>
// Look for global variables that should have been defined in the
// snippet and fall back to defaults if they haven't been defined.
const PAS = window.permittingAuthorities ? permittingAuthorities : undefined;
const COLS = window.selectedColumns ? selectedColumns : undefined;
const ENV = window.epsTableBASEURL ? epsTableBASEURL : 'https://cdx.epa.gov';
const FILS = window.epsFilters ? epsFilters : [];

import EPSDashboard from './components/EPS-Dashboard';

export default {
  name: 'eps-dash',

  components: {
    EPSDashboard
  },

  data: () => ({
    pas: PAS,
    fils: FILS,
    cols: COLS,
    env: ENV
  })
};
</script>
